import { useEffect, useRef, useState } from 'react';

export default function useDelay(value, delay, shouldDelayEnter = true) {
  const actionsRef = useRef([]);
  const [delayed, setDelayed] = useState(value);

  useEffect(() => {
    const timeout = delay * (actionsRef.current.length + 1);

    actionsRef.current.push(
      setTimeout(
        () => {
          setDelayed(value);
          actionsRef.current.shift();
        },
        !shouldDelayEnter && !!value ? 0 : timeout
      )
    );
  }, [delay, shouldDelayEnter, value]);

  return delayed;
}
